import batch_settings_mixin from './_mixin';

/**
 * 税率設定モーダル
 */
export default {
    name: 'modalBatchSettingsTax',
    template: '#modal_batch_settings_tax_template',
    data() {
        // 設定データ以外のパラメータを保持しない
        return {
            tax_included: '1',
            tax_rate: '0.1',
        };
    },
    mixins: [ batch_settings_mixin ],
};
